import { RC } from "@/utils/constants";

export const ROUTE_URL = {
  RISK_CONTROLS: "/controls",
  RISK_CONTROLS_CASES: "/api/risk-control/cases",
  RISK_CONTROLS_CASE_STATUS: "/api/risk-control/{case_id}/status",
  ROUTE_PATH_TENDER_DEVIATION: "/controls/" + RC.TD_ROUTE_PARAM,
  ROUTE_PATH_ARTICLE_NON_ARTICLE: "/controls/" + RC.ANA_ROUTE_PARAM,
  ROUTE_PATH_RR: "/controls/" + RC.RR_ROUTE_PARAM,
  ROUTE_PATH_RPA: "/controls/" + RC.RPA_ROUTE_PARAM,
  ROUTE_PATH_SG80: "/controls/" + RC.SG80_ROUTE_PARAM,
  RISK_CONTROLS_DETAILS: "/api/risk-control/{case_id}/details",
  RISK_CONTROLS_TRANSACTION: "/api/risk-control/{case_id}/transactions",
  ACTION_TOKEN: "/api/stats/accessToken",
  GET_GLS_WST_KEY: "/api/getGlsWstKey",
  ACTION_TOKEN_PATTERNS: "/api/stats/accessTokenPatterns",
  ACTION_TOKEN_AML: "/api/stats/accessTokenAML"
};

export default ROUTE_URL;
